import React, { useContext } from 'react';
import { SelectValueViewer } from 'components';
import { getObjectValue } from 'utillities';
import getOptionsAccordingApproach from './getOptionsAccordingApproach';
import DCFTVTContext from '../../context/DCFTVTContext';

const MultipleTypeApproachValueViewer = props => {
  const { cell, dcfWacc } = getObjectValue(props);
  const { revenueMultipleOptions, ebitdaMultipleOptions } = useContext(DCFTVTContext);
  const options = getOptionsAccordingApproach({ dcfWacc, cell, revenueMultipleOptions, ebitdaMultipleOptions });

  return <SelectValueViewer options={options} {...props} />;
};

export default MultipleTypeApproachValueViewer;
